import { DesktopDateTimePicker } from "@mui/x-date-pickers";
import { isValid, parseISO } from "date-fns";

import { useFieldContext } from "./form.context";

type Props = {
  label: string;
  disablePast?: boolean;
  greaterThan?: string;
};

function parseFormDateTime(value: string | Date | undefined): Date | null {
  if (value == null) return null;
  if (value instanceof Date) return isValid(value) ? value : null;
  if (typeof value !== "string" || value === "") return null;
  const parsed = parseISO(value);
  return isValid(parsed) ? parsed : null;
}

export function DateTimeField({ label, disablePast = true, greaterThan }: Props) {
  const field = useFieldContext<string | Date | undefined>();
  const errors = field.state.meta.errors;
  const hasError = field.state.meta.isTouched && errors.length > 0;
  const dateValue = parseFormDateTime(field.state.value);

  const getErrorMessage = (errors: any[]) => {
    return errors
      .map((error) => {
        if (typeof error === "string") return error;
        if (error?.message) return error.message;
        if (error?._errors?.length) return error._errors[0];
        return String(error);
      })
      .join(", ");
  };

  // Calculate min datetime
  let minDateTime: Date | undefined;
  if (disablePast) {
    minDateTime = new Date();
  }
  if (greaterThan) {
    const greaterThanDate = new Date(greaterThan);
    minDateTime =
      minDateTime && greaterThanDate > minDateTime
        ? greaterThanDate
        : greaterThan
          ? greaterThanDate
          : minDateTime;
  }
  return (
    <DesktopDateTimePicker
      label={label}
      value={dateValue}
      onChange={(date) => {
        if (date == null || !isValid(date)) {
          field.handleChange("");
          return;
        }
        field.handleChange(date.toISOString());
      }}
      disablePast={disablePast}
      minDateTime={minDateTime}
      ampm={false}
      views={["month", "day", "year", "hours", "minutes"]}
      sx={{ width: "100%" }}
      slotProps={{
        textField: {
          name: field.name,
          variant: "standard",
          fullWidth: true,
          error: hasError,
          helperText: hasError ? getErrorMessage(errors) : "",
          onBlur: field.handleBlur,
        },
      }}
    />
  );
}
